let categoryData =
{
  '/': {
    'cover': '/static/objetos/para-la-casa/mesa/posafuentes/dsc08345.jpg',
    'name': 'inicio',
    'subcategories': [
      'para-la-casa/',
      'para-bebes/',
      'para-viajar/',
      'para-nivel-inicial/',
      'para-primaria/',
      'para-jugar/',
      'para-organizar/',
      'para-mascotas/',
      'para-navidad/',
      'ambos/'
    ]
  },
  '/ambos/': {
    'cover': '/static/objetos/ambos/img-20171123-130812.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171215-wa0009.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171226-wa0002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171226-wa0003.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171101-143441.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171101-143534.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171101-143722.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171123-130733.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171123-130812.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171130-171707.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20171130-171958.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20180209-220519.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20180209-220556.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20180209-220641.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/ambos/img-20180209-220706.jpg'
      }
    ],
    'name': 'ambos'
  },
  '/para-bebes/': {
    'cover': '/static/objetos/para-bebes/panaleros/dsc08000-001.jpg',
    'name': 'para beb\u00e9s',
    'subcategories': [
      'baberos/',
      'babitas/',
      'cambiadores/',
      'sujeta-chupetes/',
      'portachupetes/',
      'sabanas/',
      'acolchados/',
      'chichoneras/',
      'apego/',
      'toallones-animales/',
      'toallones-con-capucha/',
      'nombres-en-pano-lenci/',
      'nombres-en-tela/',
      'panaleros/',
      'canastos/',
      'gimnasio-alfombra-corralito/',
      'colgantes-guirnaldas/',
      'organizadores-cosmeticos/',
      'bolsitas-de-dormir/',
      'catres/',
      'bolsitas-para-mudas/',
      'almohadones/',
      'fundas-wawita/',
      'gorros-reversibles/',
      'veladores/',
      'estuche-toallitas-humedas/'
    ]
  },
  '/para-bebes/acolchados/': {
    'cover': '/static/objetos/para-bebes/acolchados/dsc00074.jpg',
    'images': [
      {
        'name': 'CAM00094',
        'url': '/static/objetos/para-bebes/acolchados/cam00094.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc00010.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc00074.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc00536-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc01515-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc01602-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc07683.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/dsc09810-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20160410-wa0001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20161113-wa0002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20150720-191707-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20150802-211100.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20170218-204936745.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20170218-210704-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20170824-134742344.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/acolchados/img-20180202-170843.jpg'
      }
    ],
    'name': 'acolchados'
  },
  '/para-bebes/almohadones/': {
    'cover': '/static/objetos/para-bebes/almohadones/dsc09813-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc00616-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc00622-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc00741-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc01607-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc01622-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc05881-2.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc05883-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc06370-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc06374.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc07540.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc07541.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc07564.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc07610-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/dsc09813-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20161113-wa0003.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20160831-191119.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20160908-150557.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20160908-150634.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20160908-150723.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20161024-195602.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20161026-183849.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20161101-185129.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20170218-211106.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20170405-211230.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20170622-173632.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20170810-134846.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20170824-135300196.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20171011-131126.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20171030-174414.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/almohadones/img-20180102-175906.jpg'
      }
    ],
    'name': 'almohadones'
  },
  '/para-bebes/apego/': {
    'cover': '/static/objetos/para-bebes/apego/dsc00329-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00079.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00085.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00327-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00329-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00347-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00602-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00792-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00797-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00840-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc00845-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/apego/dsc01502-001.jpg'
      }
    ],
    'name': 'apego'
  },
  '/para-bebes/baberos/': {
    'cover': '/static/objetos/para-bebes/baberos/img-20170813-195210.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00031-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00330-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00335-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00340-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00348-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00475-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00480-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00483-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00488-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00604-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc00909-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01086.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01093-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01497-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01499-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01509-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01734-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01738-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc01741-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc07823-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc07825-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc07829-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/dsc07833-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20160613-141123.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20160727-214928.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20161228-171907578-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20170218-204438-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20170517-164427.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20170619-210502.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20170813-195210.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/baberos/img-20180314-165951.jpg'
      }
    ],
    'name': 'baberos'
  },
  '/para-bebes/babitas/': {
    'cover': '/static/objetos/para-bebes/babitas/img-20161013-105451.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc00356-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc00663-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc00675-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc01649-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc01652-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc01654-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc01657-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc01661-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc01663-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc05482.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc05483.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/dsc09195.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/img-20160611-191719.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/img-20161013-105451.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/img-20170831-180714346-hdr.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/img-20171115-144150.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/babitas/img-20180314-165106.jpg'
      }
    ],
    'name': 'babitas'
  },
  '/para-bebes/bolsitas-de-dormir/': {
    'cover': '/static/objetos/para-bebes/bolsitas-de-dormir/img-20170517-164514.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/dsc00750-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/dsc01565-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/dsc01750-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/dsc01756-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/img-20170202-143200.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/img-20170202-143644.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/img-20170517-164514.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-de-dormir/img-20170517-164554.jpg'
      }
    ],
    'name': 'bolsitas de dormir'
  },
  '/para-bebes/bolsitas-para-mudas/': {
    'cover': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc01081-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc00656-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc00912-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc01081-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc01090-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc01448-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc01683-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc01701-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/dsc09786-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/img-20161220-wa0016.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/img-20161013-105621.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/bolsitas-para-mudas/img-20170831-180551578.jpg'
      }
    ],
    'name': 'bolsitas para mudas'
  },
  '/para-bebes/cambiadores/': {
    'cover': '/static/objetos/para-bebes/cambiadores/dsc01385-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc00497-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc00508-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc00654-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01375-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01382-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01385-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01417-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01419-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01582-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01698-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01700-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc01713-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc05442-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc05570.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc07683-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc09192-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/dsc09798-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20161229-132254.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20170824-135437000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20170825-182048317.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20170825-182131869.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20171110-173620.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20171228-144229.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20171228-144432.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20171228-144629.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20180202-165555.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20180202-170919.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20180313-112211.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/cambiadores/img-20180313-113218.jpg'
      }
    ],
    'name': 'cambiadores'
  },
  '/para-bebes/canastos/': {
    'cover': '/static/objetos/para-bebes/canastos/img-20171214-165022.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc00549-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc00552-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc00557-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc00641-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc01114-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc01612-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/dsc01631-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20160914-165656.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20160929-180958.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20170310-174552.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20170310-174710.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20170405-211258.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20170405-211331.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20170605-150041.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20170831-182145.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20171006-161601.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/canastos/img-20171214-165022.jpg'
      }
    ],
    'name': 'canastos'
  },
  '/para-bebes/catres/': {
    'cover': '/static/objetos/para-bebes/catres/img-20170218-205756271.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/catres/dsc07669-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/catres/dsc07676-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/catres/dsc07680-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/catres/img-20170218-204936745-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/catres/img-20170218-205756271.jpg'
      }
    ],
    'name': 'catres'
  },
  '/para-bebes/chichoneras/': {
    'cover': '/static/objetos/para-bebes/chichoneras/dsc00709-001.jpg',
    'images': [
      {
        'name': 'CAM00095-001',
        'url': '/static/objetos/para-bebes/chichoneras/cam00095-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/dsc00306-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/dsc00709-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/dsc01032-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/img-20151029-wa0010.jpeg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/img-20151029-wa0012.jpeg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/img-20160831-191119.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/chichoneras/img-20161024-194834729.jpg'
      }
    ],
    'name': 'chichoneras'
  },
  '/para-bebes/colgantes-guirnaldas/': {
    'cover': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc05617.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00072.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00443-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00449-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00585-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00628-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00745-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00757-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc00849-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc01023-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc01289-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc05617.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc05654-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc08202-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc08592-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc08601-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc09181-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/dsc09283-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20150315-wa0001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20161025-wa0002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20160818-115438230-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20160915-170833-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20161014-142637947.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20161024-203633.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20161027-195015.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20170218-204954498-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/colgantes-guirnaldas/img-20170616-191905.jpg'
      }
    ],
    'name': 'colgantes-guirnaldas'
  },
  '/para-bebes/estuche-toallitas-humedas/': {
    'cover': '/static/objetos/para-bebes/estuche-toallitas-humedas/img-20180313-173454.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/estuche-toallitas-humedas/img-20180313-173454.jpg'
      }
    ],
    'name': 'estuche toallitas humedas'
  },
  '/para-bebes/fundas-wawita/': {
    'cover': '/static/objetos/para-bebes/fundas-wawita/img-20180312-162550.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/fundas-wawita/dsc01719-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/fundas-wawita/img-20161113-wa0004.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/fundas-wawita/img-20180307-183320.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/fundas-wawita/img-20180312-162550.jpg'
      }
    ],
    'name': 'fundas wawita'
  },
  '/para-bebes/gimnasio-alfombra-corralito/': {
    'cover': '/static/objetos/para-bebes/gimnasio-alfombra-corralito/dsc00714-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gimnasio-alfombra-corralito/dsc00714-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gimnasio-alfombra-corralito/dsc00718-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gimnasio-alfombra-corralito/dsc00721-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gimnasio-alfombra-corralito/dsc00724-001.jpg'
      }
    ],
    'name': 'gimnasio-alfombra-corralito'
  },
  '/para-bebes/gorros-reversibles/': {
    'cover': '/static/objetos/para-bebes/gorros-reversibles/dsc00115-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gorros-reversibles/dsc00115-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gorros-reversibles/dsc06639.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/gorros-reversibles/dsc06739.jpg'
      }
    ],
    'name': 'gorros reversibles'
  },
  '/para-bebes/nombres-en-pano-lenci/': {
    'cover': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc00702-001.jpg',
    'images': [
      {
        'name': 'CAM00161',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/cam00161.jpg'
      },
      {
        'name': 'CAM00162',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/cam00162.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc00528-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc00590-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc00699-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc00702-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc00733.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc01185-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc01595-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc09386-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc09392.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc09407-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/dsc09778-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/img-20160613-011716.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/img-20160714-235651.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-pano-lenci/img-20171110-173817.jpg'
      }
    ],
    'name': 'nombres en pa\u00f1o lenci'
  },
  '/para-bebes/nombres-en-tela/': {
    'cover': '/static/objetos/para-bebes/nombres-en-tela/img-20170213-141818-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/dsc01629-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/dsc01689-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20160729-180003700-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20160929-191853.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20170213-141818-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20170330-162258.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20171114-182558.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20180316-161407.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/nombres-en-tela/img-20180328-161503.jpg'
      }
    ],
    'name': 'nombres en tela'
  },
  '/para-bebes/organizadores-cosmeticos/': {
    'cover': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00693-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00109-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00116-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00509-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00517-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00686-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc00693-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/organizadores-cosmeticos/dsc09012.jpg'
      }
    ],
    'name': 'organizadores cosm\u00e9ticos'
  },
  '/para-bebes/panaleros/': {
    'cover': '/static/objetos/para-bebes/panaleros/dsc08005-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc01618-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc01731-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc06379.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc07671-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc07998-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc08000-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/dsc08005-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/panaleros/img-20161101-185056.jpg'
      }
    ],
    'name': 'pa\u00f1aleros'
  },
  '/para-bebes/portachupetes/': {
    'cover': '/static/objetos/para-bebes/portachupetes/dsc00917-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/portachupetes/dsc00917-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/portachupetes/dsc00925-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/portachupetes/dsc00930-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/portachupetes/dsc00932-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/portachupetes/dsc05569.jpg'
      }
    ],
    'name': 'portachupetes'
  },
  '/para-bebes/sabanas/': {
    'cover': '/static/objetos/para-bebes/sabanas/dsc01563-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc00002-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc00088-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc00538-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc00666-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc00778-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc01190-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc01193-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc01563-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc01609-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc01668-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc01672-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc06404-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc06427-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc06428-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc06441-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc06550.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc08445-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc09783-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/dsc09804-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20150720-191943-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20150720-192114-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20161013-105808.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20170519-152521.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20170519-152543.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20170831-180627963-hdr.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sabanas/img-20180202-170005-001.jpg'
      }
    ],
    'name': 's\u00e1banas'
  },
  '/para-bebes/sujeta-chupetes/': {
    'cover': '/static/objetos/para-bebes/sujeta-chupetes/dsc00761-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/dsc00523-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/dsc00761-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/dsc01100-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/dsc01295-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/dsc01703-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/img-20160727-215217.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/sujeta-chupetes/img-20161013-221645.jpg'
      }
    ],
    'name': 'sujeta chupetes'
  },
  '/para-bebes/toallones-animales/': {
    'cover': '/static/objetos/para-bebes/toallones-animales/gallina.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc05469-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc06213-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc06469-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc06474-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc06478-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc06807-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/dsc07701-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/img-20170109-171209.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-animales/img-20170109-172046.jpg'
      },
      {
        'name': 'chancho',
        'url': '/static/objetos/para-bebes/toallones-animales/chancho.jpg'
      },
      {
        'name': 'gallina',
        'url': '/static/objetos/para-bebes/toallones-animales/gallina.jpg'
      },
      {
        'name': 'hipopotamo',
        'url': '/static/objetos/para-bebes/toallones-animales/hipopotamo.jpg'
      },
      {
        'name': 'oveja',
        'url': '/static/objetos/para-bebes/toallones-animales/oveja.jpg'
      },
      {
        'name': 'panda',
        'url': '/static/objetos/para-bebes/toallones-animales/panda.jpg'
      },
      {
        'name': 'vaquita san Antonio',
        'url': '/static/objetos/para-bebes/toallones-animales/vaquita-san-antonio.jpg'
      }
    ],
    'name': 'toallones animales'
  },
  '/para-bebes/toallones-con-capucha/': {
    'cover': '/static/objetos/para-bebes/toallones-con-capucha/dsc01644-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/dsc01639-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/dsc01644-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/dsc09794-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/img-20150720-191821-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/img-20160908-150924.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/img-20161228-171800964-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/img-20170127-130912.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/img-20170831-181433815-hdr.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/toallones-con-capucha/img-20171115-144108.jpg'
      }
    ],
    'name': 'toallones con capucha'
  },
  '/para-bebes/veladores/': {
    'cover': '/static/objetos/para-bebes/veladores/dsc01475-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-bebes/veladores/dsc01475-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/veladores/dsc01485-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/veladores/dsc01489-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/veladores/dsc05813-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-bebes/veladores/img-20161013-221616.jpg'
      }
    ],
    'name': 'veladores'
  },
  '/para-jugar/': {
    'cover': '/static/objetos/para-jugar/disfraces/delantal-cocinera-nina-y-adulta.jpg',
    'name': 'para jugar',
    'subcategories': [
      'comidas-de-pano-lenci/',
      'carpas-tipis-accesorios/',
      'juegos-de-pano-lenci/',
      'bolsos-y-canastos-jugueteros/',
      'disfraces/',
      'pelotas-con-globos/',
      'ta-te-ti/',
      'catre-munecos/'
    ]
  },
  '/para-jugar/bolsos-y-canastos-jugueteros/': {
    'cover': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20170824-172926414.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/dsc01612-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20160914-165732.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20160922-173429.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20170605-145927.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20170824-172804149.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20170824-172926414.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20170825-135844344.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20170825-140002262.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/bolsos-y-canastos-jugueteros/img-20171006-161601.jpg'
      }
    ],
    'name': 'bolsos y canastos jugueteros'
  },
  '/para-jugar/carpas-tipis-accesorios/': {
    'cover': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160929-152411.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160812-194222529.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160812-194229543.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160812-194256661.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160812-194447197.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160813-155715626-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160813-211051-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160818-114830040.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160929-132917628.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160929-152330.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160929-152411.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20160929-152449.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20170810-131806258.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20170810-134639.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20170810-134728.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20170810-134807.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20170810-134827.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20170810-134913.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171002-152231312.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171002-152317730.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171002-160603419.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171002-162254.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171002-162328.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171002-162435.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171011-130836194.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171011-130906424.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171011-131014.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171011-131101.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20171011-131126.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20180102-175537.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/carpas-tipis-accesorios/img-20180102-175611.jpg'
      }
    ],
    'name': 'carpas-tipis-accesorios'
  },
  '/para-jugar/catre-munecos/': {
    'cover': '/static/objetos/para-jugar/catre-munecos/img-20180112-170029.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/catre-munecos/img-20180112-165655.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/catre-munecos/img-20180112-170005.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/catre-munecos/img-20180112-170029.jpg'
      }
    ],
    'name': 'catre mu\u00f1ecos'
  },
  '/para-jugar/comidas-de-pano-lenci/': {
    'cover': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170105-124727.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170105-124639.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170105-124727.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170508-204009.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170508-204248.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170508-204306.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-154359.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-154453.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-154803.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-155739.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-155811.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-160550.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-161344.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-161612.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-211926.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170811-212249.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170815-160547.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170815-160818.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170815-161016.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170815-161036.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170915-110518516.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170915-110831398.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170915-111030170.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170915-111802474.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170915-112100061.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20170915-112525841.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20171117-021918.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20171215-011812.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/comidas-de-pano-lenci/img-20180324-120226.jpg'
      }
    ],
    'name': 'comidas de pa\u00f1o lenci'
  },
  '/para-jugar/disfraces/': {
    'cover': '/static/objetos/para-jugar/disfraces/cocinera-2.jpg',
    'images': [
      {
        'name': 'Everest nena (1)',
        'url': '/static/objetos/para-jugar/disfraces/everest-nena-1-.jpg'
      },
      {
        'name': 'Everest nena (2)',
        'url': '/static/objetos/para-jugar/disfraces/everest-nena-2-.jpg'
      },
      {
        'name': 'M&M',
        'url': '/static/objetos/para-jugar/disfraces/m-m.jpg'
      },
      {
        'name': 'bonete a rayas',
        'url': '/static/objetos/para-jugar/disfraces/bonete-a-rayas.jpg'
      },
      {
        'name': 'bonete estampado',
        'url': '/static/objetos/para-jugar/disfraces/bonete-estampado.jpg'
      },
      {
        'name': 'bonetes rojo y gris',
        'url': '/static/objetos/para-jugar/disfraces/bonetes-rojo-y-gris.jpg'
      },
      {
        'name': 'capa super se\u00f1o reversible',
        'url': '/static/objetos/para-jugar/disfraces/capa-super-seno-reversible.jpg'
      },
      {
        'name': 'cocinera 1',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-1.jpg'
      },
      {
        'name': 'cocinera 2',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-2.jpg'
      },
      {
        'name': 'cocinera 3',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-3.jpg'
      },
      {
        'name': 'cocinera 4',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-4.jpg'
      },
      {
        'name': 'cocinera 5',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-5.jpg'
      },
      {
        'name': 'cocinera 6',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-6.jpg'
      },
      {
        'name': 'cocinera 7',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-7.jpg'
      },
      {
        'name': 'cocinera 8',
        'url': '/static/objetos/para-jugar/disfraces/cocinera-8.jpeg'
      },
      {
        'name': 'cocinero 1',
        'url': '/static/objetos/para-jugar/disfraces/cocinero-1.jpg'
      },
      {
        'name': 'delantal cocinera ni\u00f1a y adulta',
        'url': '/static/objetos/para-jugar/disfraces/delantal-cocinera-nina-y-adulta.jpg'
      },
      {
        'name': 'delantal cocinero ni\u00f1o y adulto',
        'url': '/static/objetos/para-jugar/disfraces/delantal-cocinero-nino-y-adulto.jpg'
      },
      {
        'name': 'delantal tiroles',
        'url': '/static/objetos/para-jugar/disfraces/delantal-tiroles.jpg'
      },
      {
        'name': 'delantal tirolesa',
        'url': '/static/objetos/para-jugar/disfraces/delantal-tirolesa.jpg'
      },
      {
        'name': 'detalle tiradores delantal tiroles',
        'url': '/static/objetos/para-jugar/disfraces/detalle-tiradores-delantal-tiroles.jpg'
      },
      {
        'name': 'doctor',
        'url': '/static/objetos/para-jugar/disfraces/doctor.jpg'
      },
      {
        'name': 'domadora de circo',
        'url': '/static/objetos/para-jugar/disfraces/domadora-de-circo.jpg'
      },
      {
        'name': 'gorro cocinero',
        'url': '/static/objetos/para-jugar/disfraces/gorro-cocinero.jpg'
      },
      {
        'name': 'hippie',
        'url': '/static/objetos/para-jugar/disfraces/hippie.jpg'
      },
      {
        'name': 'lorito 1',
        'url': '/static/objetos/para-jugar/disfraces/lorito-1.jpg'
      },
      {
        'name': 'lorito 2',
        'url': '/static/objetos/para-jugar/disfraces/lorito-2.jpg'
      },
      {
        'name': 'mascara conejo',
        'url': '/static/objetos/para-jugar/disfraces/mascara-conejo.jpg'
      },
      {
        'name': 'mascara mono',
        'url': '/static/objetos/para-jugar/disfraces/mascara-mono.jpg'
      },
      {
        'name': 'masha',
        'url': '/static/objetos/para-jugar/disfraces/masha.jpg'
      },
      {
        'name': 'minnie',
        'url': '/static/objetos/para-jugar/disfraces/minnie.jpg'
      },
      {
        'name': 'piojo',
        'url': '/static/objetos/para-jugar/disfraces/piojo.jpg'
      },
      {
        'name': 'presentadora de circo',
        'url': '/static/objetos/para-jugar/disfraces/presentadora-de-circo.jpg'
      },
      {
        'name': 'tu tu bailarina rojo',
        'url': '/static/objetos/para-jugar/disfraces/tu-tu-bailarina-rojo.jpg'
      },
      {
        'name': 'tutu bailarina verde',
        'url': '/static/objetos/para-jugar/disfraces/tutu-bailarina-verde.jpg'
      }
    ],
    'name': 'disfraces'
  },
  '/para-jugar/juegos-de-pano-lenci/': {
    'cover': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20170906-140908.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/dsc00786-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/dsc00791-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/dsc00835.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/dsc00857.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/dsc00861-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/dsc00862-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20170906-140908.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20170906-141410.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20171229-152015.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20171229-152718.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20180304-204503.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/juegos-de-pano-lenci/img-20180304-204624.jpg'
      }
    ],
    'name': 'juegos de pa\u00f1o lenci'
  },
  '/para-jugar/pelotas-con-globos/': {
    'cover': '/static/objetos/para-jugar/pelotas-con-globos/dsc07162.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/pelotas-con-globos/dsc07162.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/pelotas-con-globos/dsc07216.jpg'
      }
    ],
    'name': 'pelotas con globos'
  },
  '/para-jugar/ta-te-ti/': {
    'cover': '/static/objetos/para-jugar/ta-te-ti/dsc08372.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-jugar/ta-te-ti/dsc06792.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/ta-te-ti/dsc07934.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-jugar/ta-te-ti/dsc08372.jpg'
      }
    ],
    'name': 'ta-te-ti'
  },
  '/para-la-casa/': {
    'cover': '/static/objetos/para-la-casa/decoracion/cortinas/dscn2287.jpg',
    'name': 'para la casa',
    'subcategories': [
      'cocina/',
      'mesa/',
      'living/',
      'bano/',
      'dormitorio/',
      'decoracion/'
    ]
  },
  '/para-la-casa/bano/': {
    'cover': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/dsc08996.jpg',
    'name': 'ba\u00f1o',
    'subcategories': [
      'toallas-y-toallones/',
      'turbantes-de-toalla/',
      'portacosmeticos/',
      'alfombras/',
      'esponjas/',
      'portarrollos-papel-higienico/',
      'canastos-de-tela/',
      'colitas-para-el-pelo/'
    ]
  },
  '/para-la-casa/bano/alfombras/': {
    'cover': '/static/objetos/para-la-casa/bano/alfombras/dsc05761.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/alfombras/dsc00867-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/alfombras/dsc05758.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/alfombras/dsc05760.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/alfombras/dsc05761.jpg'
      }
    ],
    'name': 'alfombras'
  },
  '/para-la-casa/bano/canastos-de-tela/': {
    'cover': '/static/objetos/para-la-casa/bano/canastos-de-tela/dsc00234-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/canastos-de-tela/dsc00234-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/canastos-de-tela/dsc00238-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/canastos-de-tela/img-20160908-151047.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/canastos-de-tela/img-20160908-151153.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/canastos-de-tela/img-20161024-203410.jpg'
      }
    ],
    'name': 'canastos de tela'
  },
  '/para-la-casa/bano/colitas-para-el-pelo/': {
    'cover': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc00377-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc00369-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc00370-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc00377-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc08909-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc09020-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc09023-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc09065-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/dsc09398-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/colitas-para-el-pelo/img-20150706-132055-001.jpg'
      }
    ],
    'name': 'colitas para el pelo'
  },
  '/para-la-casa/bano/esponjas/': {
    'cover': '/static/objetos/para-la-casa/bano/esponjas/dsc08274.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/esponjas/dsc08274.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/esponjas/dsc09251.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/esponjas/img-20160613-174655.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/esponjas/img-20161012-185455473.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/esponjas/img-20170906-142106.jpg'
      }
    ],
    'name': 'esponjas'
  },
  '/para-la-casa/bano/portacosmeticos/': {
    'cover': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193759.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00228-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00879-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00883-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00886-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00893-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00902-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc00947-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01202-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01205-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01211-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01259-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01263-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01265-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01271-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc01273-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc05936.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc08279.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc08284.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/dsc08928.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20160802-185354.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20160921-211233-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193536.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193717.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193759.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193827.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193903.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20161117-193937.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20170906-193149.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portacosmeticos/img-20171020-135206.jpg'
      }
    ],
    'name': 'portacosm\u00e9ticos'
  },
  '/para-la-casa/bano/portarrollos-papel-higienico/': {
    'cover': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/img-20180207-165759.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/dsc01518-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/dsc08996.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/dsc09010.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/img-20171003-185013.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/portarrollos-papel-higienico/img-20180207-165759.jpg'
      }
    ],
    'name': 'portarrollos papel higi\u00e9nico'
  },
  '/para-la-casa/bano/toallas-y-toallones/': {
    'cover': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc09353-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc00378-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc00414-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc00595-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06211-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06383.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06386.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06392.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06509-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06519-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06521-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc06614-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc07195-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc07198-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc07295-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc07299-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc07612.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc08359-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc08361-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc09188-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/dsc09353-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/toallas-y-toallones/img-20160908-151012.jpg'
      }
    ],
    'name': 'toallas y toallones'
  },
  '/para-la-casa/bano/turbantes-de-toalla/': {
    'cover': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/dsc01276-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/dsc00360-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/dsc01276-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/dsc05697-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/dsc06313-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/dsc09288.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/bano/turbantes-de-toalla/img-20150619-wa0003.jpg'
      }
    ],
    'name': 'turbantes de toalla'
  },
  '/para-la-casa/cocina/': {
    'cover': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20171207-121421.jpg',
    'name': 'cocina',
    'subcategories': [
      'portabolsas/',
      'agarraderas/',
      'canastos-de-tela/',
      'repasadores/',
      'delantales/',
      'fundas/',
      'fundas-botellones-20l/'
    ]
  },
  '/para-la-casa/cocina/agarraderas/': {
    'cover': '/static/objetos/para-la-casa/cocina/agarraderas/img-20161009-213805.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc00041-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc00108.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc01258.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc05559.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc05902-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06207.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06208.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06219.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06223.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06304-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06306-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06461.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06462.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06628.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06636.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc06716.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc07737.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc07738.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc07820.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08194.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08199.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08560.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08665-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08936.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08940.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08944.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08949.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08952.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08963-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc08985.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09124.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09300.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09303.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09305-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09339.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09340.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09345.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09349.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/dsc09350.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20150428-wa0000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20170403-wa0006.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20161009-213805.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20161009-213839.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20161009-213916.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20161125-182340.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/img-20170427-185710396.jpg'
      },
      {
        'name': 'agarradera doble corazon-2',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/agarradera-doble-corazon-2.jpg'
      },
      {
        'name': 'agarradera doble corazon',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/agarradera-doble-corazon.jpg'
      },
      {
        'name': 'agarradera mamuschka',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/agarradera-mamuschka.jpg'
      },
      {
        'name': 'agarradera manijas',
        'url': '/static/objetos/para-la-casa/cocina/agarraderas/agarradera-manijas.jpg'
      }
    ],
    'name': 'agarraderas'
  },
  '/para-la-casa/cocina/canastos-de-tela/': {
    'cover': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20171218-220442.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20170619-210855.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20171207-121255.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20171207-121421.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20171207-121448.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20171218-220442.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/canastos-de-tela/img-20180114-144220.jpg'
      }
    ],
    'name': 'canastos de tela'
  },
  '/para-la-casa/cocina/delantales/': {
    'cover': '/static/objetos/para-la-casa/cocina/delantales/dsc00727-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc00318-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc00406-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc00727-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc05543.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc06201-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc06215-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc06790-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc07306-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/dsc08308-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/delantales/img-20170619-210716.jpg'
      }
    ],
    'name': 'delantales'
  },
  '/para-la-casa/cocina/fundas-botellones-20l/': {
    'cover': '/static/objetos/para-la-casa/cocina/fundas-botellones-20l/foto0029.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/fundas-botellones-20l/dsc07205.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/fundas-botellones-20l/dsc07210.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/fundas-botellones-20l/dsc08368.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/fundas-botellones-20l/foto0029.jpg'
      }
    ],
    'name': 'fundas botellones 20l'
  },
  '/para-la-casa/cocina/fundas/': {
    'cover': '/static/objetos/para-la-casa/cocina/fundas/funda-hornito.jpg',
    'images': [
      {
        'name': 'funda  cafetera frente',
        'url': '/static/objetos/para-la-casa/cocina/fundas/funda-cafetera-frente.jpg'
      },
      {
        'name': 'funda  lavarropas abierta',
        'url': '/static/objetos/para-la-casa/cocina/fundas/funda-lavarropas-abierta.jpg'
      },
      {
        'name': 'funda cafetera vista superior',
        'url': '/static/objetos/para-la-casa/cocina/fundas/funda-cafetera-vista-superior.jpg'
      },
      {
        'name': 'funda hornito',
        'url': '/static/objetos/para-la-casa/cocina/fundas/funda-hornito.jpg'
      },
      {
        'name': 'funda lavarropas cerrrada',
        'url': '/static/objetos/para-la-casa/cocina/fundas/funda-lavarropas-cerrrada.jpg'
      }
    ],
    'name': 'fundas'
  },
  '/para-la-casa/cocina/portabolsas/': {
    'cover': '/static/objetos/para-la-casa/cocina/portabolsas/dsc09328-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00195-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00802-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00804-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00813-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00817-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00827-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00831-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc00956-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc05576.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc05610.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc05621-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc05622.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc05832-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc05873-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc06298.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc06567.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc07730.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc08474.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc08973-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc09328-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/dsc09441-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/img-20160727-215133-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/img-20170427-185559.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/img-20170508-113317.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/portabolsas/img-20170913-174224204.jpg'
      }
    ],
    'name': 'portabolsas'
  },
  '/para-la-casa/cocina/repasadores/': {
    'cover': '/static/objetos/para-la-casa/cocina/repasadores/img-20171207-121143.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/dsc00284-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/dsc00287-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/dsc00291-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/dsc05730.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/dsc05752.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/dsc09298-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20161116-180407.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20161116-180436.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20161116-180530.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20161116-180600.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20161116-180626.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20171207-121143.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/cocina/repasadores/img-20171207-121341.jpg'
      }
    ],
    'name': 'repasadores'
  },
  '/para-la-casa/decoracion/': {
    'cover': '/static/objetos/para-la-casa/decoracion/almohadones/dsc05919-1.jpg',
    'name': 'decoraci\u00f3n',
    'subcategories': [
      'banderines/',
      'colgantes-y-guirnaldas/',
      'cortinas/',
      'canastos-de-tela/',
      'almohadones/',
      'alfombras/',
      'cactus-de-tela/',
      'flores-de-tela/',
      'nombres-en-pano-lenci/',
      'nombres-en-tela/'
    ]
  },
  '/para-la-casa/decoracion/alfombras/': {
    'cover': '/static/objetos/para-la-casa/decoracion/alfombras/img-20170810-134639.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/alfombras/img-20170810-134639.jpg'
      }
    ],
    'name': 'alfombras'
  },
  '/para-la-casa/decoracion/almohadones/': {
    'cover': '/static/objetos/para-la-casa/decoracion/almohadones/img-20180327-165101.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/dsc01589-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/dsc01747-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/dsc05919-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/dsc05940.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/dsc07573-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20160502-wa0006-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20161102-wa0008.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20161024-203531.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20171013-173033.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20171013-173108.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20171024-182213.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20171214-164520.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20180303-203901.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/img-20180327-165101.jpg'
      },
      {
        'name': 'almohadon galletita leche',
        'url': '/static/objetos/para-la-casa/decoracion/almohadones/almohadon-galletita-leche.jpg'
      }
    ],
    'name': 'almohadones'
  },
  '/para-la-casa/decoracion/banderines/': {
    'cover': '/static/objetos/para-la-casa/decoracion/banderines/img-20160714-235811-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/dsc06234.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/dsc06255.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/dsc07556.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/dsc08161.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/dsc08351.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20160714-235811-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20160831-122006-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20160913-185735.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170105-130626.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170105-131344.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170113-014404.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170113-014441.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170113-014503.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170113-014558.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170127-131044.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20170901-181231.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20171121-151722.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/banderines/img-20180326-160256.jpg'
      }
    ],
    'name': 'banderines'
  },
  '/para-la-casa/decoracion/cactus-de-tela/': {
    'cover': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00966-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00430-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00940-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00963-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00966-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00971-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00974-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc00978-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc05770-003.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06242.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06244-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06245.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06246-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06247.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06248-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06249-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc06250.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc07597-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/dsc08366-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cactus-de-tela/img-20180118-150905544.jpg'
      }
    ],
    'name': 'cactus de tela'
  },
  '/para-la-casa/decoracion/canastos-de-tela/': {
    'cover': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20161013-105244.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc00549-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc00552-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc00557-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc00641-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc00776-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc01108-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc01112-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc01114-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc01631-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc01726-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/dsc01731-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20170907-wa0005.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20160611-203754.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20160826-163916-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20161013-105220.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20161013-105244.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20161013-105316.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20170119-183912.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20170417-161653.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20170417-162118.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20171006-161601.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20171214-165022.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20180305-162237.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20180313-173216.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/canastos-de-tela/img-20180313-173548.jpg'
      }
    ],
    'name': 'canastos de tela'
  },
  '/para-la-casa/decoracion/colgantes-y-guirnaldas/': {
    'cover': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00246-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00246-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00585-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00628-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00745-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00757-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc00849-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc01023-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc01289-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc01312-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc01493.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc05616.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc05653.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc05654-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc07592.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc07955.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc07982.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08069.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08146-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08154.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08157-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08202-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08224.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08229-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08236-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08592-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc08601-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc09181-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/dsc09283-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20161025-wa0003.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20170914-wa0000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20160818-115438230-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20160915-170833-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20160929-191853.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20161014-142637947.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20161024-203633.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20161027-195015.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20170218-204954498-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/colgantes-y-guirnaldas/img-20170616-191905.jpg'
      }
    ],
    'name': 'colgantes y guirnaldas'
  },
  '/para-la-casa/decoracion/cortinas/': {
    'cover': '/static/objetos/para-la-casa/decoracion/cortinas/dscn2296.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/dsc00162.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/dsc05738.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/dscn2287.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/dscn2290.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/dscn2296.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/img-20140308-wa0000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/cortinas/img-20150106-wa0008-001.jpg'
      }
    ],
    'name': 'cortinas'
  },
  '/para-la-casa/decoracion/flores-de-tela/': {
    'cover': '/static/objetos/para-la-casa/decoracion/flores-de-tela/dsc00563-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/flores-de-tela/dsc00563-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/flores-de-tela/dsc00575-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/flores-de-tela/img-20150428-wa0004.jpeg'
      }
    ],
    'name': 'flores de tela'
  },
  '/para-la-casa/decoracion/nombres-en-pano-lenci/': {
    'cover': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/img-20160714-235651.jpg',
    'images': [
      {
        'name': 'CAM00161',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/cam00161.jpg'
      },
      {
        'name': 'CAM00162',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/cam00162.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc00528-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc00590-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc00699-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc00702-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc00733.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc01185-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc01595-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc09386-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc09392.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/dsc09407-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/img-20160613-011716.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/img-20160714-235651.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-pano-lenci/img-20171110-173817.jpg'
      }
    ],
    'name': 'nombres en pa\u00f1o lenci'
  },
  '/para-la-casa/decoracion/nombres-en-tela/': {
    'cover': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/dsc01689-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/dsc01629-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/dsc01689-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/img-20160729-180003700-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/img-20160929-191853.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/img-20170213-141818-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/img-20170330-162258.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/decoracion/nombres-en-tela/img-20171114-182558.jpg'
      }
    ],
    'name': 'nombres en tela'
  },
  '/para-la-casa/dormitorio/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/canastos-de-tela/img-20171003-185852344.jpg',
    'name': 'dormitorio',
    'subcategories': [
      'acolchados/',
      'fundas-almohadas/',
      'almohadones/',
      'porta-pijamas/',
      'canastos-de-tela/',
      'antifaces/'
    ]
  },
  '/para-la-casa/dormitorio/acolchados/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc07751.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc05526.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc05527-2.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc05630.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc05631.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc07751.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/acolchados/dsc07752.jpg'
      }
    ],
    'name': 'acolchados'
  },
  '/para-la-casa/dormitorio/almohadones/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/almohadones/dsc06226.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/dsc04763.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/dsc05914-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/dsc06226.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/dsc06504.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/dsc07562.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/img-20160106-wa0005.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/img-20170517-135310858-hdr.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/img-20171218-220129.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/almohadones/img-20171218-220236.jpg'
      }
    ],
    'name': 'almohadones'
  },
  '/para-la-casa/dormitorio/antifaces/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/antifaces/dsc06434.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/antifaces/dsc06434.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/antifaces/dsc06435.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/antifaces/dsc07547.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/antifaces/dsc09136.jpg'
      }
    ],
    'name': 'antifaces'
  },
  '/para-la-casa/dormitorio/canastos-de-tela/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/canastos-de-tela/img-20171003-185852344.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/canastos-de-tela/dsc01042-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/canastos-de-tela/img-20171003-185852344.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/canastos-de-tela/img-20180215-160009.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/canastos-de-tela/img-20180215-160222.jpg'
      }
    ],
    'name': 'canastos de tela'
  },
  '/para-la-casa/dormitorio/fundas-almohadas/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07759.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07754.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07759.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07760.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07763.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07768.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/fundas-almohadas/dsc07771.jpg'
      }
    ],
    'name': 'fundas almohadas'
  },
  '/para-la-casa/dormitorio/porta-pijamas/': {
    'cover': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc09370.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc05436.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc05461.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc05536.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc05537.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc06367.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc06371.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc07337.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc07465.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc07733.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc08702.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc08709.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc09358.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc09365.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/dormitorio/porta-pijamas/dsc09370.jpg'
      }
    ],
    'name': 'porta pijamas'
  },
  '/para-la-casa/living/': {
    'cover': '/static/objetos/para-la-casa/living/almohadones/dsc00387.jpg',
    'name': 'living',
    'subcategories': [
      'fundas-sillones/',
      'almohadones/'
    ]
  },
  '/para-la-casa/living/almohadones/': {
    'cover': '/static/objetos/para-la-casa/living/almohadones/img-20160611-203611.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/dsc00093.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/dsc00104.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/dsc00387.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/dsc07397.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/dsc07450.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/img-20160611-203611.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/almohadones/img-20161026-183925.jpg'
      }
    ],
    'name': 'almohadones'
  },
  '/para-la-casa/living/fundas-sillones/': {
    'cover': '/static/objetos/para-la-casa/living/fundas-sillones/dsc06238.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/dsc00168.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/dsc00542-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/dsc01466.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/dsc06238.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/img-20160418-wa0004.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/img-20160720-wa0006.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/img-sillon-adriana.png'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/img-20170427-191031.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/living/fundas-sillones/img-20170614-132602.jpg'
      }
    ],
    'name': 'fundas sillones'
  },
  '/para-la-casa/mesa/': {
    'cover': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc09225-001.jpg',
    'name': 'mesa',
    'subcategories': [
      'manteles/',
      'caminos-de-mesa/',
      'almohadones/',
      'paneras/',
      'posafuentes/',
      'canastos-servilleteros/'
    ]
  },
  '/para-la-casa/mesa/almohadones/': {
    'cover': '/static/objetos/para-la-casa/mesa/almohadones/dsc04768.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/almohadones/dsc04768.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/almohadones/img-20150319-wa0002.jpg'
      }
    ],
    'name': 'almohadones'
  },
  '/para-la-casa/mesa/caminos-de-mesa/': {
    'cover': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc09229-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc00464.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc00470.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc00610-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc06414-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc06421-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc06422-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc06425-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc09225-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/dsc09229-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/img-20150319-wa0003-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/img-20150714-wa0004.jpeg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/caminos-de-mesa/img-20180124-134508.jpg'
      }
    ],
    'name': 'caminos de mesa'
  },
  '/para-la-casa/mesa/canastos-servilleteros/': {
    'cover': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20171207-121217.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20170112-194004.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20170112-194033.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20170112-194109.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20171207-121217.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20171218-220504.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20171218-220536.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/canastos-servilleteros/img-20171219-133324.jpg'
      }
    ],
    'name': 'canastos servilleteros'
  },
  '/para-la-casa/mesa/manteles/': {
    'cover': '/static/objetos/para-la-casa/mesa/manteles/img-20171206-190430.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc04762.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc05896-1.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc06407.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc06437.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc06495.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc07177.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc08447.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc08781.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/dsc09234.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/img-20151212-wa0000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/img-20170906-141509.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/img-20171025-171346.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/img-20171206-190430.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/img-20180108-141439.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/manteles/img-20180305-161550.jpg'
      }
    ],
    'name': 'manteles'
  },
  '/para-la-casa/mesa/paneras/': {
    'cover': '/static/objetos/para-la-casa/mesa/paneras/dsc00632-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/dsc00632-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/dsc06773-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/dsc07311-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/dsc07445-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/dsc07849-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/dsc08270-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/img-20171219-174002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/paneras/img-20171219-174017.jpg'
      }
    ],
    'name': 'paneras'
  },
  '/para-la-casa/mesa/posafuentes/': {
    'cover': '/static/objetos/para-la-casa/mesa/posafuentes/dsc05553.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc05534.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc05553.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc05660.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc07802.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc08119.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc08345.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/dsc09278.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/img-20180215-160610.jpg'
      },
      {
        'name': 'posafuentes frisa petalos',
        'url': '/static/objetos/para-la-casa/mesa/posafuentes/posafuentes-frisa-petalos.jpg'
      }
    ],
    'name': 'posafuentes'
  },
  '/para-mascotas/': {
    'cover': '/static/objetos/para-mascotas/almohadones/img-20161125-174447.jpg',
    'name': 'para mascotas',
    'subcategories': [
      'cuchas/',
      'canastos-para-juguetes/',
      'juguetes/',
      'almohadones/',
      'mantelitos/'
    ]
  },
  '/para-mascotas/almohadones/': {
    'cover': '/static/objetos/para-mascotas/almohadones/dsc04887.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/almohadones/dsc04887.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/almohadones/img-20161205-wa0013.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/almohadones/img-20161125-174447.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/almohadones/img-20161125-175112.jpg'
      }
    ],
    'name': 'almohadones'
  },
  '/para-mascotas/canastos-para-juguetes/': {
    'cover': '/static/objetos/para-mascotas/canastos-para-juguetes/dsc04879.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/dsc00204-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/dsc04879.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/dsc04880.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/dsc09175-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/img-20171226-wa0005.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/img-20161125-173854.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/canastos-para-juguetes/img-20171218-220413.jpg'
      }
    ],
    'name': 'canastos para juguetes'
  },
  '/para-mascotas/cuchas/': {
    'cover': '/static/objetos/para-mascotas/cuchas/img-20170110-wa0000.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/dsc00458.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/dsc08106.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/dsc08496.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/img-20150716-wa0002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/img-20161220-wa0013.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/img-20170110-wa0000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/cuchas/img01041-20130919-2121.jpg'
      }
    ],
    'name': 'cuchas'
  },
  '/para-mascotas/juguetes/': {
    'cover': '/static/objetos/para-mascotas/juguetes/dsc09064.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/juguetes/dsc08114.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/juguetes/dsc08260.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/juguetes/dsc09062.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/juguetes/dsc09064.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/juguetes/dsc09130.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/juguetes/img-20170619-211019.jpg'
      }
    ],
    'name': 'juguetes'
  },
  '/para-mascotas/mantelitos/': {
    'cover': '/static/objetos/para-mascotas/mantelitos/img-20171226-wa0006.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/mantelitos/img-20171226-wa0006.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-mascotas/mantelitos/img-20171214-170133.jpg'
      }
    ],
    'name': 'mantelitos'
  },
  '/para-navidad/': {
    'cover': '/static/objetos/para-navidad/roscas/rosca-papa-noel.jpg',
    'name': 'para navidad',
    'subcategories': [
      'arbolitos/',
      'roscas/',
      'adornos/',
      'varios/'
    ]
  },
  '/para-navidad/adornos/': {
    'cover': '/static/objetos/para-navidad/adornos/colgante-estrellas.jpg',
    'images': [
      {
        'name': 'banderin navide\u00f1o',
        'url': '/static/objetos/para-navidad/adornos/banderin-navideno.jpg'
      },
      {
        'name': 'bota reno',
        'url': '/static/objetos/para-navidad/adornos/bota-reno.jpg'
      },
      {
        'name': 'bota santa',
        'url': '/static/objetos/para-navidad/adornos/bota-santa.jpg'
      },
      {
        'name': 'cara santa claus',
        'url': '/static/objetos/para-navidad/adornos/cara-santa-claus.jpg'
      },
      {
        'name': 'colgante buho',
        'url': '/static/objetos/para-navidad/adornos/colgante-buho.jpg'
      },
      {
        'name': 'colgante estrella-galleta-arbol',
        'url': '/static/objetos/para-navidad/adornos/colgante-estrella-galleta-arbol.jpg'
      },
      {
        'name': 'colgante estrellas',
        'url': '/static/objetos/para-navidad/adornos/colgante-estrellas.jpg'
      },
      {
        'name': 'colgante muerdago-reno-santa',
        'url': '/static/objetos/para-navidad/adornos/colgante-muerdago-reno-santa.jpg'
      },
      {
        'name': 'trio santa reno nieve',
        'url': '/static/objetos/para-navidad/adornos/trio-santa-reno-nieve.jpg'
      }
    ],
    'name': 'adornos'
  },
  '/para-navidad/arbolitos/': {
    'cover': '/static/objetos/para-navidad/arbolitos/pino-estrella-blanca.jpg',
    'images': [
      {
        'name': 'arbolito colgante',
        'url': '/static/objetos/para-navidad/arbolitos/arbolito-colgante.jpg'
      },
      {
        'name': 'arbolito conos',
        'url': '/static/objetos/para-navidad/arbolitos/arbolito-conos.jpg'
      },
      {
        'name': 'arbolito estrellas',
        'url': '/static/objetos/para-navidad/arbolitos/arbolito-estrellas.jpg'
      },
      {
        'name': 'pino cascabeles',
        'url': '/static/objetos/para-navidad/arbolitos/pino-cascabeles.jpg'
      },
      {
        'name': 'pino estrella blanca',
        'url': '/static/objetos/para-navidad/arbolitos/pino-estrella-blanca.jpg'
      }
    ],
    'name': 'arbolitos'
  },
  '/para-navidad/roscas/': {
    'cover': '/static/objetos/para-navidad/roscas/rosca-trenzada-con-rosas.jpg',
    'images': [
      {
        'name': 'rosca 13 rosas',
        'url': '/static/objetos/para-navidad/roscas/rosca-13-rosas.jpg'
      },
      {
        'name': 'rosca 8 rosas',
        'url': '/static/objetos/para-navidad/roscas/rosca-8-rosas.jpg'
      },
      {
        'name': 'rosca angelito-estrella',
        'url': '/static/objetos/para-navidad/roscas/rosca-angelito-estrella.jpg'
      },
      {
        'name': 'rosca corazones',
        'url': '/static/objetos/para-navidad/roscas/rosca-corazones.jpg'
      },
      {
        'name': 'rosca mo\u00f1os',
        'url': '/static/objetos/para-navidad/roscas/rosca-monos.jpg'
      },
      {
        'name': 'rosca mullida roja',
        'url': '/static/objetos/para-navidad/roscas/rosca-mullida-roja.jpg'
      },
      {
        'name': 'rosca mullida rojo-verde',
        'url': '/static/objetos/para-navidad/roscas/rosca-mullida-rojo-verde.jpg'
      },
      {
        'name': 'rosca mullida verde',
        'url': '/static/objetos/para-navidad/roscas/rosca-mullida-verde.jpg'
      },
      {
        'name': 'rosca organza roja',
        'url': '/static/objetos/para-navidad/roscas/rosca-organza-roja.jpg'
      },
      {
        'name': 'rosca organza verde',
        'url': '/static/objetos/para-navidad/roscas/rosca-organza-verde.jpg'
      },
      {
        'name': 'rosca papa noel',
        'url': '/static/objetos/para-navidad/roscas/rosca-papa-noel.jpg'
      },
      {
        'name': 'rosca torzada-mo\u00f1o',
        'url': '/static/objetos/para-navidad/roscas/rosca-torzada-mono.jpg'
      },
      {
        'name': 'rosca trenzada con rosas',
        'url': '/static/objetos/para-navidad/roscas/rosca-trenzada-con-rosas.jpg'
      }
    ],
    'name': 'roscas'
  },
  '/para-navidad/varios/': {
    'cover': '/static/objetos/para-navidad/varios/delantal-santa.jpg',
    'images': [
      {
        'name': 'delantal santa',
        'url': '/static/objetos/para-navidad/varios/delantal-santa.jpg'
      },
      {
        'name': 'toalla de mano',
        'url': '/static/objetos/para-navidad/varios/toalla-de-mano.jpg'
      }
    ],
    'name': 'varios'
  },
  '/para-nivel-inicial/': {
    'cover': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-cuadrille-.jpg',
    'name': 'para nivel inicial',
    'subcategories': [
      'guardapolvos-docentes/',
      'pintorcitos/',
      'accesorios/',
      'aplicaciones/',
      'pecheras-bandas/'
    ]
  },
  '/para-nivel-inicial/accesorios/': {
    'cover': '/static/objetos/para-nivel-inicial/accesorios/img-20170203-184554.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc01425-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc01430-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc01439-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc01443-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc06395.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc06396.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc07123.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc07182-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc07184-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc07188-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc07243-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/dsc08887-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20160611-191808.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20160611-191922.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20161116-180153.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170203-184554.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170203-185356.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170210-192413.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170210-192947.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170310-103833.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170310-144246.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170321-172943.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20170907-151913.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180124-133157.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180130-150746.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180207-165849.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180209-123339.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180209-123456.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180306-134813.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180306-134849.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180307-163354.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180307-163521.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180307-163706.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180309-140335.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180309-140550.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/accesorios/img-20180312-141151.jpg'
      }
    ],
    'name': 'accesorios'
  },
  '/para-nivel-inicial/aplicaciones/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc01497.jpg',
    'name': 'aplicaciones',
    'subcategories': [
      'animales/',
      'flores/',
      'deportes/',
      'herramientas/',
      'vehiculos/',
      'personajes/',
      'nombres/',
      'varios/',
      'remeras-aplicadas/'
    ]
  },
  '/para-nivel-inicial/aplicaciones/animales/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/animales/mariposa1.jpg',
    'images': [
      {
        'name': 'abejas1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/abejas1.jpg'
      },
      {
        'name': 'abejas2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/abejas2.jpg'
      },
      {
        'name': 'ardilla1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/ardilla1.jpg'
      },
      {
        'name': 'ardilla2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/ardilla2.jpg'
      },
      {
        'name': 'ballenas1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/ballenas1.jpg'
      },
      {
        'name': 'buho1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/buho1.jpg'
      },
      {
        'name': 'buho2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/buho2.jpg'
      },
      {
        'name': 'buho3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/buho3.jpg'
      },
      {
        'name': 'buhos1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/buhos1.jpg'
      },
      {
        'name': 'buhos2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/buhos2.jpg'
      },
      {
        'name': 'burro1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/burro1.jpg'
      },
      {
        'name': 'caballo1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/caballo1.jpg'
      },
      {
        'name': 'caballo2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/caballo2.jpg'
      },
      {
        'name': 'caballo3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/caballo3.jpg'
      },
      {
        'name': 'cerca-pajaritos',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/cerca-pajaritos.jpg'
      },
      {
        'name': 'chancho1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/chancho1.jpg'
      },
      {
        'name': 'chivo1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/chivo1.jpg'
      },
      {
        'name': 'ciervoyardilla',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/ciervoyardilla.jpg'
      },
      {
        'name': 'cocodrilo',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/cocodrilo.jpg'
      },
      {
        'name': 'conejo1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/conejo1.jpg'
      },
      {
        'name': 'conejo2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/conejo2.jpg'
      },
      {
        'name': 'conejo3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/conejo3.jpg'
      },
      {
        'name': 'dino1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/dino1.jpg'
      },
      {
        'name': 'elefante1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/elefante1.jpg'
      },
      {
        'name': 'elefante2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/elefante2.jpg'
      },
      {
        'name': 'elefantes1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/elefantes1.jpg'
      },
      {
        'name': 'gallina1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gallina1.jpg'
      },
      {
        'name': 'gallina2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gallina2.jpg'
      },
      {
        'name': 'gato1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gato1.jpg'
      },
      {
        'name': 'gato2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gato2.jpg'
      },
      {
        'name': 'gato3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gato3.jpg'
      },
      {
        'name': 'gatos1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gatos1.jpg'
      },
      {
        'name': 'gatos2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/gatos2.jpg'
      },
      {
        'name': 'hipo1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/hipo1.jpg'
      },
      {
        'name': 'hipo2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/hipo2.jpg'
      },
      {
        'name': 'huellitas',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/huellitas.jpg'
      },
      {
        'name': 'jirafa1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/jirafa1.jpg'
      },
      {
        'name': 'jirafa2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/jirafa2.jpg'
      },
      {
        'name': 'leon1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/leon1.jpg'
      },
      {
        'name': 'leon2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/leon2.jpg'
      },
      {
        'name': 'leon3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/leon3.jpg'
      },
      {
        'name': 'mariposa1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/mariposa1.jpg'
      },
      {
        'name': 'mariposas1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/mariposas1.jpg'
      },
      {
        'name': 'mono1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/mono1.jpg'
      },
      {
        'name': 'osopolar1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/osopolar1.jpg'
      },
      {
        'name': 'osopolar2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/osopolar2.jpg'
      },
      {
        'name': 'oveja1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/oveja1.jpg'
      },
      {
        'name': 'ovejas1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/ovejas1.jpg'
      },
      {
        'name': 'ovejas2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/ovejas2.jpg'
      },
      {
        'name': 'pajarito-nido',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajarito-nido.jpg'
      },
      {
        'name': 'pajarito1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajarito1.jpg'
      },
      {
        'name': 'pajarito2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajarito2.jpg'
      },
      {
        'name': 'pajaritos1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajaritos1.jpg'
      },
      {
        'name': 'pajaritos2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajaritos2.jpg'
      },
      {
        'name': 'pajaritos3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajaritos3.jpg'
      },
      {
        'name': 'pajaritos4',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajaritos4.jpg'
      },
      {
        'name': 'pajaro1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pajaro1.jpg'
      },
      {
        'name': 'pato1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pato1.jpg'
      },
      {
        'name': 'pato2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/pato2.jpg'
      },
      {
        'name': 'perro1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/perro1.jpg'
      },
      {
        'name': 'perro2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/perro2.jpg'
      },
      {
        'name': 'perro3',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/perro3.jpg'
      },
      {
        'name': 'perro5',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/perro5.jpg'
      },
      {
        'name': 'perro6',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/perro6.jpg'
      },
      {
        'name': 'rama-pajarito',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/rama-pajarito.jpg'
      },
      {
        'name': 'rino1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/rino1.jpg'
      },
      {
        'name': 'tiburon',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/tiburon.jpg'
      },
      {
        'name': 'vaca-pasto',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/vaca-pasto.jpg'
      },
      {
        'name': 'vaca1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/vaca1.jpg'
      },
      {
        'name': 'vaquitassanantonio',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/vaquitassanantonio.jpg'
      },
      {
        'name': 'vaquitaymariposa',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/vaquitaymariposa.jpg'
      },
      {
        'name': 'zorro1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/zorro1.jpg'
      },
      {
        'name': 'zorro2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/animales/zorro2.jpg'
      }
    ],
    'name': 'animales'
  },
  '/para-nivel-inicial/aplicaciones/deportes/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/deportes/camiseta-velez-sarsfield.jpg',
    'images': [
      {
        'name': 'camiseta barcelona',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/deportes/camiseta-barcelona.jpg'
      },
      {
        'name': 'camiseta velez sarsfield',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/deportes/camiseta-velez-sarsfield.jpg'
      },
      {
        'name': 'pelota boca',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/deportes/pelota-boca.jpg'
      },
      {
        'name': 'pelota futbol',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/deportes/pelota-futbol.jpg'
      },
      {
        'name': 'pelota rugby',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/deportes/pelota-rugby.jpg'
      }
    ],
    'name': 'deportes'
  },
  '/para-nivel-inicial/aplicaciones/flores/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/flores/tulipanes.jpg',
    'images': [
      {
        'name': 'cactus',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/cactus.jpg'
      },
      {
        'name': 'flor simple 2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/flor-simple-2.jpg'
      },
      {
        'name': 'flor simple',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/flor-simple.jpg'
      },
      {
        'name': 'media flor libelula',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/media-flor-libelula.jpg'
      },
      {
        'name': 'media flor mariposa',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/media-flor-mariposa.jpg'
      },
      {
        'name': 'media flor',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/media-flor.jpg'
      },
      {
        'name': 'tres flores',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/tres-flores.jpg'
      },
      {
        'name': 'tulipanes',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/flores/tulipanes.jpg'
      }
    ],
    'name': 'flores'
  },
  '/para-nivel-inicial/aplicaciones/herramientas/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/herramientas/herramientas.jpg',
    'images': [
      {
        'name': 'herramientas',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/herramientas/herramientas.jpg'
      }
    ],
    'name': 'herramientas'
  },
  '/para-nivel-inicial/aplicaciones/nombres/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/img-20170218-204438.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc01497.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc01509.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc01734.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc01738.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc01741.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc07130-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/dsc08770.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/img-20160613-141123.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/img-20170218-204438.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/img-20170517-164427.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/img-20170619-210502.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/nombres/img-20180314-165811-001.jpg'
      }
    ],
    'name': 'nombres'
  },
  '/para-nivel-inicial/aplicaciones/personajes/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/hulk.jpg',
    'images': [
      {
        'name': 'america',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/america.jpg'
      },
      {
        'name': 'ara\u00f1a fondo rojo',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/arana-fondo-rojo.jpg'
      },
      {
        'name': 'ara\u00f1a negro',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/arana-negro.jpg'
      },
      {
        'name': 'ara\u00f1a rojo',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/arana-rojo.jpg'
      },
      {
        'name': 'bruja',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/bruja.jpg'
      },
      {
        'name': 'callie',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/callie.jpg'
      },
      {
        'name': 'cars',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/cars.jpg'
      },
      {
        'name': 'duende',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/duende.jpg'
      },
      {
        'name': 'flash',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/flash.jpg'
      },
      {
        'name': 'george y dino',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/george-y-dino.jpg'
      },
      {
        'name': 'hada1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/hada1.jpg'
      },
      {
        'name': 'hada2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/hada2.jpg'
      },
      {
        'name': 'hulk',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/hulk.jpg'
      },
      {
        'name': 'mamushka',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/mamushka.jpg'
      },
      {
        'name': 'payaso',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/payaso.jpg'
      },
      {
        'name': 'peppa',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/peppa.jpg'
      },
      {
        'name': 'princesa',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/princesa.jpg'
      },
      {
        'name': 'robot',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/robot.jpg'
      },
      {
        'name': 'rocky',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/rocky.jpg'
      },
      {
        'name': 'sapa pepa',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/sapa-pepa.jpg'
      },
      {
        'name': 'sapo pepe',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/sapo-pepe.jpg'
      },
      {
        'name': 'sarah kay 1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/sarah-kay-1.jpg'
      },
      {
        'name': 'sarah kay 2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/sarah-kay-2.jpg'
      },
      {
        'name': 'superman',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/superman.jpg'
      },
      {
        'name': 'woody',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/personajes/woody.jpg'
      }
    ],
    'name': 'personajes'
  },
  '/para-nivel-inicial/aplicaciones/remeras-aplicadas/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20161230-153457.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20151214-wa0001.jpeg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20161230-153457.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20170628-204343.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20170628-204424.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20170628-204504.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/remeras-aplicadas/img-20170628-204553.jpg'
      }
    ],
    'name': 'remeras aplicadas'
  },
  '/para-nivel-inicial/aplicaciones/varios/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/varios/corazon-patch.jpg',
    'images': [
      {
        'name': 'bosillo patch',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/varios/bosillo-patch.jpg'
      },
      {
        'name': 'corazon patch',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/varios/corazon-patch.jpg'
      },
      {
        'name': 'corona',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/varios/corona.jpg'
      },
      {
        'name': 'guitarra',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/varios/guitarra.jpg'
      },
      {
        'name': 'muffin',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/varios/muffin.jpg'
      },
      {
        'name': 'sandia',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/varios/sandia.jpg'
      }
    ],
    'name': 'varios'
  },
  '/para-nivel-inicial/aplicaciones/vehiculos/': {
    'cover': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/tractor.jpg',
    'images': [
      {
        'name': 'avion',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/avion.jpg'
      },
      {
        'name': 'camioneta',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/camioneta.jpg'
      },
      {
        'name': 'cohete 1',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/cohete-1.jpg'
      },
      {
        'name': 'cohete 2',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/cohete-2.jpg'
      },
      {
        'name': 'helicoptero',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/helicoptero.jpg'
      },
      {
        'name': 'moto',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/moto.jpg'
      },
      {
        'name': 'submarino',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/submarino.jpg'
      },
      {
        'name': 'tractor',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/tractor.jpg'
      },
      {
        'name': 'triciclo',
        'url': '/static/objetos/para-nivel-inicial/aplicaciones/vehiculos/triciclo.jpg'
      }
    ],
    'name': 'vehiculos'
  },
  '/para-nivel-inicial/guardapolvos-docentes/': {
    'cover': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/poncho-arciel-color-con-cuello.jpg',
    'name': 'guardapolvos docentes',
    'subcategories': [
      'guardapolvos-sin-mangas/',
      'guardapolvos-manga-corta/',
      'guardapolvos-manga-larga/',
      'bolsos/'
    ]
  },
  '/para-nivel-inicial/guardapolvos-docentes/bolsos/': {
    'cover': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/bolsos/cuerina-chico-rosa.jpg',
    'images': [
      {
        'name': 'arciel cuerina interior con cierre',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/bolsos/arciel-cuerina-interior-con-cierre.jpg'
      },
      {
        'name': 'cuerina chico beige',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/bolsos/cuerina-chico-beige.jpg'
      },
      {
        'name': 'cuerina chico rosa',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/bolsos/cuerina-chico-rosa.jpg'
      },
      {
        'name': 'lona mediano',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/bolsos/lona-mediano.jpg'
      }
    ],
    'name': 'bolsos'
  },
  '/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-corta/': {
    'cover': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-corta/abierto-adelante-arciel-blanco-bies-en-mangas.jpg',
    'images': [
      {
        'name': 'abierto adelante arciel blanco bies en mangas',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-corta/abierto-adelante-arciel-blanco-bies-en-mangas.jpg'
      }
    ],
    'name': 'guardapolvos manga corta'
  },
  '/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/': {
    'cover': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-cuadrille-con-volado-en-escote-y-bolsillo-elastico-en-punos.jpg',
    'images': [
      {
        'name': 'abierto adelante arciel blanco broderie en cuello y bolsillos',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/abierto-adelante-arciel-blanco-broderie-en-cuello-y-bolsillos.jpg'
      },
      {
        'name': 'abierto adelante arciel blanco con cuello smoking',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/abierto-adelante-arciel-blanco-con-cuello-smoking.jpg'
      },
      {
        'name': 'abierto adelante cuadrille bies en cuello',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/abierto-adelante-cuadrille-bies-en-cuello.jpg'
      },
      {
        'name': 'basico arciel blanco con bies en cuello',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-arciel-blanco-con-bies-en-cuello.jpg'
      },
      {
        'name': 'basico cuadrille con bies en cuello pu\u00f1os y ruedo',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-cuadrille-con-bies-en-cuello-punos-y-ruedo.jpg'
      },
      {
        'name': 'basico cuadrille con broderie en cuello y bolsillo',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-cuadrille-con-broderie-en-cuello-y-bolsillo.jpg'
      },
      {
        'name': 'basico cuadrille con cuello volado bolsillo elastico en pu\u00f1os',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-cuadrille-con-cuello-volado-bolsillo-elastico-en-punos.jpg'
      },
      {
        'name': 'basico cuadrille con cuello',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-cuadrille-con-cuello.jpg'
      },
      {
        'name': 'basico cuadrille con volado en escote y bolsillo elastico en pu\u00f1os',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-manga-larga/basico-cuadrille-con-volado-en-escote-y-bolsillo-elastico-en-punos.jpg'
      }
    ],
    'name': 'guardapolvos manga larga'
  },
  '/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/': {
    'cover': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-jean-azul.jpg',
    'images': [
      {
        'name': 'basico abierto adelante arciel blanco bolsillo con cierre',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-abierto-adelante-arciel-blanco-bolsillo-con-cierre.jpg'
      },
      {
        'name': 'basico abierto adelante arciel color con cuello',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-abierto-adelante-arciel-color-con-cuello.jpg'
      },
      {
        'name': 'basico abierto adelante cuadrille con cuello',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-abierto-adelante-cuadrille-con-cuello.jpg'
      },
      {
        'name': 'basico arciel blanco',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-arciel-blanco.jpg'
      },
      {
        'name': 'basico arciel color con cuello y manga voladito',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-arciel-color-con-cuello-y-manga-voladito.jpg'
      },
      {
        'name': 'basico cuadrille ',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-cuadrille-.jpg'
      },
      {
        'name': 'basico cuadrille volado bolsillo',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-cuadrille-volado-bolsillo.jpg'
      },
      {
        'name': 'basico cuadrille volado escote y bolsillo',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-cuadrille-volado-escote-y-bolsillo.jpg'
      },
      {
        'name': 'basico jean azul',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-jean-azul.jpg'
      },
      {
        'name': 'basico jean celeste',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/basico-jean-celeste.jpg'
      },
      {
        'name': 'cerrado arciel color con  volado en cuello y bolsillos',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/cerrado-arciel-color-con-volado-en-cuello-y-bolsillos.jpg'
      },
      {
        'name': 'cruzado  arciel blanco delantero',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/cruzado-arciel-blanco-delantero.jpg'
      },
      {
        'name': 'cruzado arciel blanco espalda',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/cruzado-arciel-blanco-espalda.jpg'
      },
      {
        'name': 'cruzado arciel color bolsillos con cierre',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/cruzado-arciel-color-bolsillos-con-cierre.jpg'
      },
      {
        'name': 'cruzado cuadrille delantero',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/cruzado-cuadrille-delantero.jpg'
      },
      {
        'name': 'cruzado cuadrille espalda',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/cruzado-cuadrille-espalda.jpg'
      },
      {
        'name': 'poncho arciel blanco',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/poncho-arciel-blanco.jpg'
      },
      {
        'name': 'poncho arciel color con cuello',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/poncho-arciel-color-con-cuello.jpg'
      },
      {
        'name': 'poncho cuadrille',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/poncho-cuadrille.jpg'
      },
      {
        'name': 'poncho jean sin broches',
        'url': '/static/objetos/para-nivel-inicial/guardapolvos-docentes/guardapolvos-sin-mangas/poncho-jean-sin-broches.jpg'
      }
    ],
    'name': 'guardapolvos sin mangas'
  },
  '/para-nivel-inicial/pecheras-bandas/': {
    'cover': '/static/objetos/para-nivel-inicial/pecheras-bandas/img-20160623-wa0006.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/pecheras-bandas/img-20160623-wa0006.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/pecheras-bandas/img-20170321-162108.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-nivel-inicial/pecheras-bandas/img-20170321-172909.jpg'
      }
    ],
    'name': 'pecheras-bandas'
  },
  '/para-nivel-inicial/pintorcitos/': {
    'cover': '/static/objetos/para-nivel-inicial/pintorcitos/basico-nena-volado-bolsillo.jpg',
    'images': [
      {
        'name': 'basico nena volado bolsillo',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/basico-nena-volado-bolsillo.jpg'
      },
      {
        'name': 'basico nena volado en cuello y bolsillo',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/basico-nena-volado-en-cuello-y-bolsillo.jpg'
      },
      {
        'name': 'basico nena',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/basico-nena.jpg'
      },
      {
        'name': 'basico varon',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/basico-varon.jpg'
      },
      {
        'name': 'manga larga  nena',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/manga-larga-nena.jpg'
      },
      {
        'name': 'manga larga nena broderie bolsillo y cuello',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/manga-larga-nena-broderie-bolsillo-y-cuello.jpg'
      },
      {
        'name': 'manga larga nena volado bolsillo',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/manga-larga-nena-volado-bolsillo.jpg'
      },
      {
        'name': 'manga larga varon',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/manga-larga-varon.jpg'
      },
      {
        'name': 'manga voladito nena volado bolsillo',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/manga-voladito-nena-volado-bolsillo.jpg'
      },
      {
        'name': 'uisex con tiradores',
        'url': '/static/objetos/para-nivel-inicial/pintorcitos/uisex-con-tiradores.jpg'
      }
    ],
    'name': 'pintorcitos'
  },
  '/para-organizar/': {
    'cover': '/static/objetos/para-organizar/porta-bijou/dsc01227-001.jpg',
    'name': 'para organizar',
    'subcategories': [
      'canastos/',
      'bolsilleros/',
      'fundas-pvc/',
      'para-dispositivos-electronicos/',
      'estuches-para-calzado/',
      'fundas-articulos-deportivos/',
      'bolso-botiquin/',
      'porta-bijou/'
    ]
  },
  '/para-organizar/bolsilleros/': {
    'cover': '/static/objetos/para-organizar/bolsilleros/img-20160611-203640.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20160611-203640.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20160705-154748-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20160706-134253-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20160706-134356-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20160922-172522.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20180110-192933.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolsilleros/img-20180110-192957.jpg'
      }
    ],
    'name': 'bolsilleros'
  },
  '/para-organizar/bolso-botiquin/': {
    'cover': '/static/objetos/para-organizar/bolso-botiquin/img-20170619-210558.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolso-botiquin/img-20170602-172319.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolso-botiquin/img-20170602-172407.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolso-botiquin/img-20170602-172446.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolso-botiquin/img-20170619-210538.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/bolso-botiquin/img-20170619-210558.jpg'
      }
    ],
    'name': 'bolso botiqu\u00edn'
  },
  '/para-organizar/canastos/': {
    'cover': '/static/objetos/para-organizar/canastos/img-20170417-161653.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/dsc00641-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/dsc00776-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/dsc01108-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/dsc01112-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/dsc01726-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/img-20160611-203754.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/img-20160826-163916-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/img-20161013-105220.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/img-20170417-161653.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/img-20170417-162118.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/canastos/img-20171214-165022.jpg'
      }
    ],
    'name': 'canastos'
  },
  '/para-organizar/estuches-para-calzado/': {
    'cover': '/static/objetos/para-organizar/estuches-para-calzado/img-20171206-wa0006.jpeg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/estuches-para-calzado/img-20171206-wa0006.jpeg'
      }
    ],
    'name': 'estuches para calzado'
  },
  '/para-organizar/fundas-articulos-deportivos/': {
    'cover': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160805-175747532-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/dsc01366.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/dsc01369.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/dsc01569-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/dsc01572-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160630-002949-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160630-003043-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160630-003113-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160805-175002652-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160805-175542246-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160805-175615697-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160805-175747532-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-articulos-deportivos/img-20160805-175833203-001.jpg'
      }
    ],
    'name': 'fundas art\u00edculos deportivos'
  },
  '/para-organizar/fundas-pvc/': {
    'cover': '/static/objetos/para-organizar/fundas-pvc/img-20160908-150756.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/dsc01587-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20160614-201753.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20160615-192304.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20160712-123052.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20160826-155718-002.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20160908-150756.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20161012-184138345.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20161027-194642.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20170309-161753.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20170310-103920.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20170405-211015.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20170405-211056.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20170405-211136.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/fundas-pvc/img-20170505-200131464.jpg'
      }
    ],
    'name': 'fundas pvc'
  },
  '/para-organizar/para-dispositivos-electronicos/': {
    'cover': '/static/objetos/para-organizar/para-dispositivos-electronicos/bolsos/dsc07301.jpg',
    'name': 'para dispositivos electr\u00f3nicos',
    'subcategories': [
      'fundas/',
      'porta-cargadores/',
      'bolsos/'
    ]
  },
  '/para-organizar/para-dispositivos-electronicos/bolsos/': {
    'cover': '/static/objetos/para-organizar/para-dispositivos-electronicos/bolsos/dsc07301.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/bolsos/dsc07289.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/bolsos/dsc07301.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/bolsos/dsc08062.jpg'
      }
    ],
    'name': 'bolsos'
  },
  '/para-organizar/para-dispositivos-electronicos/fundas/': {
    'cover': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc08263.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc00034.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc00036.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc00783-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc07169.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc07173.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc07742.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc08020-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc08023.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/dsc08263.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/img-20170418-152234.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/fundas/img-20170418-152311.jpg'
      }
    ],
    'name': 'fundas'
  },
  '/para-organizar/para-dispositivos-electronicos/porta-cargadores/': {
    'cover': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01436-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01012-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01306-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01309-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01332.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01431-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/dsc01436-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/img-20161012-184823717.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/para-dispositivos-electronicos/porta-cargadores/img-20170614-132627.jpg'
      }
    ],
    'name': 'porta cargadores'
  },
  '/para-organizar/porta-bijou/': {
    'cover': '/static/objetos/para-organizar/porta-bijou/dsc01227-001.jpg',
    'images': [
      {
        'name': 'CAM00192',
        'url': '/static/objetos/para-organizar/porta-bijou/cam00192.jpg'
      },
      {
        'name': 'CAM00193',
        'url': '/static/objetos/para-organizar/porta-bijou/cam00193.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc00274-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc00275-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc01227-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc01232-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc01236-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc01245-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-organizar/porta-bijou/dsc01678-001.jpg'
      }
    ],
    'name': 'porta bijou'
  },
  '/para-primaria/': {
    'cover': '/static/objetos/para-primaria/funda-flauta/img-20170403-174901.jpg',
    'name': 'para primaria',
    'subcategories': [
      'cartucheras/',
      'carpetas/',
      'fundas-para-cuadernos/',
      'bolsas/',
      'fundas-pvc/',
      'funda-flauta/',
      'banderas-estandartes/'
    ]
  },
  '/para-primaria/banderas-estandartes/': {
    'cover': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-180647.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20160705-154838-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-175957.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-180025.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-180647.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-181454.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-182736387.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170425-183053493.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170609-174444.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170609-174542.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170926-140456.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/banderas-estandartes/img-20170926-140630.jpg'
      }
    ],
    'name': 'banderas-estandartes'
  },
  '/para-primaria/bolsas/': {
    'cover': '/static/objetos/para-primaria/bolsas/bolsa-carpeta-nro6-jean.jpg',
    'images': [
      {
        'name': 'bolsa carpeta nro6 jean',
        'url': '/static/objetos/para-primaria/bolsas/bolsa-carpeta-nro6-jean.jpg'
      }
    ],
    'name': 'bolsas'
  },
  '/para-primaria/carpetas/': {
    'cover': '/static/objetos/para-primaria/carpetas/img-20170315-155013-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-primaria/carpetas/dsc01403.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/carpetas/img-20170315-154935-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/carpetas/img-20170315-155013-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/carpetas/img-20180214-170501.jpg'
      }
    ],
    'name': 'carpetas'
  },
  '/para-primaria/cartucheras/': {
    'cover': '/static/objetos/para-primaria/cartucheras/img-20161218-181756586.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc00989-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc01410.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc01411.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc01459.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc01462.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc06356-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc06358-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc07158-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc07160-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc07270-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc07275-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08826-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08841-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08850.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08853-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08920-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08924-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08927-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc08928-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc09012-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc09015-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/dsc09056-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20161218-181756586.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20170310-103920.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20170315-155013.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20170315-155047-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20170315-155118.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20170405-211056.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/cartucheras/img-20170405-211136.jpg'
      }
    ],
    'name': 'cartucheras'
  },
  '/para-primaria/funda-flauta/': {
    'cover': '/static/objetos/para-primaria/funda-flauta/img-20170403-174923.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-primaria/funda-flauta/img-20170403-174901.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-primaria/funda-flauta/img-20170403-174923.jpg'
      }
    ],
    'name': 'funda flauta'
  },
  '/para-primaria/fundas-para-cuadernos/': {
    'cover': '/static/objetos/para-primaria/fundas-para-cuadernos/dsc01400.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-primaria/fundas-para-cuadernos/dsc01400.jpg'
      }
    ],
    'name': 'fundas para cuadernos'
  },
  '/para-primaria/fundas-pvc/': {
    'cover': '/static/objetos/para-primaria/fundas-pvc/img-20160615-192304.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-primaria/fundas-pvc/img-20160615-192304.jpg'
      }
    ],
    'name': 'fundas pvc'
  },
  '/para-viajar/': {
    'cover': '/static/objetos/para-viajar/estuches-calzado/img-20171206-wa0006.jpeg',
    'name': 'para viajar',
    'subcategories': [
      'etiquetas-equipaje/',
      'bolsos/',
      'bolsos-materos/',
      'fundas-pvc/',
      'portavalores/',
      'fundas-objetos/',
      'porta-bijou/',
      'estuches-calzado/',
      'botiquines/',
      'estuches-proteccion-femenina/',
      'portacosmeticos/',
      'billeteras/',
      'bolsitas-para-el-auto/',
      'para-la-playa/'
    ]
  },
  '/para-viajar/billeteras/': {
    'cover': '/static/objetos/para-viajar/billeteras/img-20160614-201523.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/dsc01001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/dsc01009-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/img-20160614-201523.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/img-20160614-201647.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/img-20160714-235920.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/img-20160715-000006-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/img-20171003-191504095.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/billeteras/img-20171003-191613890.jpg'
      }
    ],
    'name': 'billeteras'
  },
  '/para-viajar/bolsitas-para-el-auto/': {
    'cover': '/static/objetos/para-viajar/bolsitas-para-el-auto/dsc01347.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/dsc01219-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/dsc01223.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/dsc01339.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/dsc01347.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/dsc01352.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/img-20151215-wa0000.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsitas-para-el-auto/img-20170809-184922.jpg'
      }
    ],
    'name': 'bolsitas para el auto'
  },
  '/para-viajar/bolsos-materos/': {
    'cover': '/static/objetos/para-viajar/bolsos-materos/img-20160826-155834.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos-materos/img-20160818-172227.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos-materos/img-20160826-155801-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos-materos/img-20160826-155834.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos-materos/img-20160826-155914.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos-materos/img-20160826-160012-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos-materos/img-20171218-220351.jpg'
      }
    ],
    'name': 'bolsos materos'
  },
  '/para-viajar/bolsos/': {
    'cover': '/static/objetos/para-viajar/bolsos/dsc05511.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos/dsc05510.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos/dsc05511.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos/dsc05703.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos/dsc05709.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/bolsos/dsc07285.jpg'
      }
    ],
    'name': 'bolsos'
  },
  '/para-viajar/botiquines/': {
    'cover': '/static/objetos/para-viajar/botiquines/img-20180315-143713.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20170624-220510885.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20170624-220608812-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20170629-162045170.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20170629-162102763.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20171003-191236181.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20171003-191246684.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20171003-191339151.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20171003-191421426.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152447.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152510.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152536.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152604.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152631.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152704.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152751.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152819.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152915.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-152937.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-153006.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-153029.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-153053.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-153129.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180114-153150.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180315-143645.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/botiquines/img-20180315-143713.jpg'
      }
    ],
    'name': 'botiquines'
  },
  '/para-viajar/estuches-calzado/': {
    'cover': '/static/objetos/para-viajar/estuches-calzado/img-20171206-wa0006.jpeg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-calzado/img-20171206-wa0006.jpeg'
      }
    ],
    'name': 'estuches calzado'
  },
  '/para-viajar/estuches-proteccion-femenina/': {
    'cover': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20171023-124357.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20170623-203744382.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20170623-203753829.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20170623-203837093.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20171023-124357.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20171023-124617.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20171023-125320.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/estuches-proteccion-femenina/img-20171023-125343.jpg'
      }
    ],
    'name': 'estuches proteccion femenina'
  },
  '/para-viajar/etiquetas-equipaje/': {
    'cover': '/static/objetos/para-viajar/etiquetas-equipaje/dsc01768.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/etiquetas-equipaje/dsc01768.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/etiquetas-equipaje/img-20161012-185859733.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/etiquetas-equipaje/img-20161027-195105.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/etiquetas-equipaje/img-20170315-155215-001.jpg'
      }
    ],
    'name': 'etiquetas equipaje'
  },
  '/para-viajar/fundas-objetos/': {
    'cover': '/static/objetos/para-viajar/fundas-objetos/img-20170622-wa0020.jpeg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/fundas-objetos/img-20170622-wa0018.jpeg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/fundas-objetos/img-20170622-wa0020.jpeg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/fundas-objetos/img-20170517-164633.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/fundas-objetos/img-20170517-164703.jpg'
      }
    ],
    'name': 'fundas objetos'
  },
  '/para-viajar/fundas-pvc/': {
    'cover': '/static/objetos/para-viajar/fundas-pvc/dsc01762.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/fundas-pvc/dsc01762.jpg'
      }
    ],
    'name': 'fundas pvc'
  },
  '/para-viajar/para-la-playa/': {
    'cover': '/static/objetos/para-viajar/para-la-playa/bolsos/img-20170410-153503.jpg',
    'name': 'para la playa',
    'subcategories': [
      'batas-de-toalla/',
      'ponchos-de-toalla/',
      'toallones-mochila/',
      'bolsos/',
      'lonas/'
    ]
  },
  '/para-viajar/para-la-playa/batas-de-toalla/': {
    'cover': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc07474.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc00875-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc05928-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc05930.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc05933-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc05934-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc06682-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc06684-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc07474.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc07478.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc07717-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc08016-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc09080-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/dsc09093-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/batas-de-toalla/img-20170120-161940.jpg'
      }
    ],
    'name': 'batas de toalla'
  },
  '/para-viajar/para-la-playa/bolsos/': {
    'cover': '/static/objetos/para-viajar/para-la-playa/bolsos/dsc08285.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/bolsos/dsc08285.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/bolsos/dsc08288.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/bolsos/dsc08292.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/bolsos/dsc08294.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/bolsos/dsc08298.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/bolsos/img-20170410-153503.jpg'
      }
    ],
    'name': 'bolsos'
  },
  '/para-viajar/para-la-playa/lonas/': {
    'cover': '/static/objetos/para-viajar/para-la-playa/lonas/dsc01278-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/lonas/dsc01278-001.jpg'
      }
    ],
    'name': 'lonas'
  },
  '/para-viajar/para-la-playa/ponchos-de-toalla/': {
    'cover': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06706-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06689-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06704-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06705-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06706-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06709-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06822-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc06826-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc08048.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc08486.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc08490.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc09155.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/ponchos-de-toalla/dsc09158.jpg'
      }
    ],
    'name': 'ponchos de toalla'
  },
  '/para-viajar/para-la-playa/toallones-mochila/': {
    'cover': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc06759-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc06759-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc06796-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc06800-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc08316-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc08317-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/para-la-playa/toallones-mochila/dsc08323-001.jpg'
      }
    ],
    'name': 'toallones mochila'
  },
  '/para-viajar/porta-bijou/': {
    'cover': '/static/objetos/para-viajar/porta-bijou/6.jpg',
    'images': [
      {
        'name': '1',
        'url': '/static/objetos/para-viajar/porta-bijou/1.jpg'
      },
      {
        'name': '2',
        'url': '/static/objetos/para-viajar/porta-bijou/2.jpg'
      },
      {
        'name': '3',
        'url': '/static/objetos/para-viajar/porta-bijou/3.jpg'
      },
      {
        'name': '4',
        'url': '/static/objetos/para-viajar/porta-bijou/4.jpg'
      },
      {
        'name': '5',
        'url': '/static/objetos/para-viajar/porta-bijou/5.jpg'
      },
      {
        'name': '6',
        'url': '/static/objetos/para-viajar/porta-bijou/6.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/dsc00265-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/dsc01226-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/dsc01240-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/dsc09004-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/dsc09006-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/img-20160921-211116.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/porta-bijou/img-20160921-211155.jpg'
      }
    ],
    'name': 'porta bijou'
  },
  '/para-viajar/portacosmeticos/': {
    'cover': '/static/objetos/para-viajar/portacosmeticos/dsc01265-001.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc00893-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc00902-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc00947-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01202-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01205-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01211-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01263-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01265-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01271-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc01273-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc08927.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc09015.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/dsc09056.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20160802-185034.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20160802-185354.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20160921-211233-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161117-193536.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161117-193717.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161117-193759.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161117-193827.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161117-193903.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161117-193937.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20161216-182038538.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portacosmeticos/img-20171020-135132504.jpg'
      }
    ],
    'name': 'portacosm\u00e9ticos'
  },
  '/para-viajar/portavalores/': {
    'cover': '/static/objetos/para-viajar/portavalores/img-20160613-154558.jpg',
    'images': [
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portavalores/dsc01761-001.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portavalores/img-20160613-154558.jpg'
      },
      {
        'name': '',
        'url': '/static/objetos/para-viajar/portavalores/img-20160822-151004187-001.jpg'
      }
    ],
    'name': 'portavalores'
  }
}
module.exports = {categoryData}



// WEBPACK FOOTER //
// ./src/categories.js